module.exports = __webpack_public_path__ + "img/icon_invest.da13d71c.svg";